// Marks shared by the workflow cards and the workflow page: enabled or not, and the agent,
// model, Docker and approval badges.
import type { Workflow } from "../../api/client";
import { useT } from "../../i18n";
import { DotStatus, Mono, Pill } from "../../ui/status";
import { cliName } from "../format";
import { policyActions } from "../policy";

export function EnabledMark({ enabled }: { enabled: boolean }) {
  const t = useT().workloads.workflow;
  return <DotStatus tone={enabled ? "green" : "gray"} label={enabled ? t.enabled : t.disabled} />;
}

export function WorkflowBadges({ workflow }: { workflow: Workflow }) {
  const t = useT().workloads.workflow;
  const approval = policyActions(workflow.tool_policy).some((a) => a.requiresApproval);
  return (
    <div className="flex flex-wrap gap-1.5">
      <Pill tone="gray">{cliName(workflow.cli_provider)}</Pill>
      {workflow.model ? (
        <Pill tone="gray">
          <Mono className="text-[11.5px] text-inherit">{workflow.model}</Mono>
        </Pill>
      ) : null}
      {workflow.needs_docker ? <Pill tone="blue">{t.dockerSidecar}</Pill> : null}
      {approval ? <Pill tone="orange">{t.approvalRequired}</Pill> : null}
    </div>
  );
}
